module.exports = __webpack_public_path__ + "img/cardBanner.456a9e2c.png";